import React, { useState, useEffect } from 'react';
import ReactPlayer from 'react-player';

import Box from '@mui/material/Box';
import { Button, Grid, Stack, Typography } from '@mui/material';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import StopCircleIcon from '@mui/icons-material/StopCircle';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const colorList = ['error', 'primary', 'secondary', 'warning', 'info', 'success', 'neutral']

const tvList = [
    {
        name: 'CCTV',
        link: 'https://www.youtube.com/watch?v=9sE12tg3CmA',
        color: 'error',
    },
    {
        name: '中天',
        link: 'https://www.youtube.com/watch?v=LDTJNqRl1uk',
        color: 'error',
    },
    {
        name: 'TVBS55',
        link: 'https://www.youtube.com/watch?v=2mCSYvcfhtc',
        color: 'info',
    },
    {
        name: 'TVBS HD',
        link: 'https://www.youtube.com/watch?v=YvdcZ_jpLXE',
        color: 'info',
    },
    {
        name: '民視',
        link: 'https://www.youtube.com/watch?v=ylYJSBUgaMA',
        color: 'primary',
    },
    {
        name: '三立',
        link: 'https://www.youtube.com/watch?v=FoBfXvlOR6I',
        color: 'primary',
    },
    {
        name: 'iNEWS',
        link: 'https://www.youtube.com/watch?v=CKjSm5ZeehE',
        color: 'primary',
    },
    {
        name: '東森',
        link: 'https://www.youtube.com/watch?v=S5WOGu2HSes',
        color: 'warning',
    },
    {
        name: '華視',
        link: 'https://www.youtube.com/watch?v=wM0g8EoUZ_E',
        color: 'warning',
    },
    {
        name: 'Sky News',
        link: 'https://www.youtube.com/watch?v=9Auq9mYxFEE',
        color: 'secondary',
    },
    {
        name: 'CNA',
        link: 'https://www.youtube.com/watch?v=XWq5kBlakcQ',
        color: 'secondary',
    },
    {
        name: 'NBC',
        link: 'https://www.youtube.com/watch?v=mlx-e8lfbbY',
        color: 'secondary',
    },
    {
        name: 'IndiaTV',
        link: 'https://www.youtube.com/watch?v=Xmm3Kr5P1Uw',
        color: 'secondary',
    },
    {
        name: 'JapaNews24',
        link: 'https://www.youtube.com/watch?v=coYw-eVU0Ks',
        color: 'secondary',
    },
    {
        name: '気象',
        link: 'https://www.youtube.com/watch?v=t4K-ayirWck',
        color: 'secondary',
    },
]

const boxStyle = {
    display: 'flex',
    flexDirection: 'row',
    px: 2,
    pt: 2,
    pb: 1,
}

const TVPlayer = () => {
    const [playUrl, setPlayUrl] = useState()
    const [isPlaying, setIsPlaying] = useState(true)
    const [isMuted, setIsMuted] = useState(true)

    const theme = useTheme();
    const matches_xs = useMediaQuery(theme.breakpoints.only('xs'));
    const matches_sm = useMediaQuery(theme.breakpoints.only('sm'));
    const matches_md = useMediaQuery(theme.breakpoints.only('md'));
    const matches_lg = useMediaQuery(theme.breakpoints.only('lg'));
    const matches_xl = useMediaQuery(theme.breakpoints.only('xl'));

    const stylesPlayerHeight = () => {
        let styles = {
            height: '100%'
        }
        if (matches_xs)
            styles.height = `250px`
        if (matches_sm)
            styles.height = `350px`
        if (matches_md)
            styles.height = `420px`
        if (matches_lg)
            styles.height = `500px`
        if (matches_xl)
            styles.height = `600px`

        console.log(styles)
        return styles
    }

    const setPlayChannel = async (tv) => {
        setPlayUrl(tv.link)
        await weblog(tv)
    }

    const weblog = async (tv) => {
        await fetch('https://vbcrgsnc11.execute-api.ap-northeast-1.amazonaws.com/mydev/tv', {
            method: 'POST',
            body: JSON.stringify({
                tvnm: tv.name,
            }),
            headers: {
                'user-agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/93.0.4577.82 Safari/537.36',
                'content-type': 'application/json'
            },
        })
    }

    useEffect(() => {
        setPlayChannel(tvList[0])
    }, [])

    const btn_tv_click = (tv) => {
        setPlayChannel(tv)
    }

    const playButtonIcon = () => {
        if (isPlaying)
            return (
                <StopCircleIcon />
            )
        else
            return (
                <PlayCircleIcon />
            )
    }
    const muteButtonIcon = () => {
        if (isMuted)
            return (
                <VolumeOffIcon />
            )
        else
            return (
                <VolumeUpIcon />
            )
    }

    const getColorIndex = (index) => {
        return colorList[index % colorList.length]
    }

    return (
        <React.Fragment>
            <Box sx={{ ...boxStyle }}>
                <Typography variant="h4" component="div" color="neutral.main" sx={{ fontWeight: 800 }}>TV选局</Typography>
            </Box>

            <Stack direction='column' sx={{ px: 2 }}>
                <Box sx={{ bgcolor: 'whitesmoke', pb: 1 }}>
                    {tvList.map((item, index) => (
                        <Button key={item.name} variant='contained' color={item.color} sx={{ ml: 1, mt: 1 }} onClick={() => btn_tv_click(item)}>{item.name}</Button>
                    ))}
                </Box>

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={12} lg={8}>
                        <Box sx={{ border: '10px solid darkslategray', ...stylesPlayerHeight() }}>
                            <ReactPlayer url={playUrl} controls={true} playing={isPlaying} muted={isMuted} width="100%" height="100%" />
                        </Box>
                    </Grid>
                </Grid>

                <Box sx={{ bgcolor: 'aliceblue', display: 'flex', justifyContent: 'flex-start', py: 2 }}>
                    <Button variant='contained'
                        sx={{ ml: 1 }}
                        color="youtube"
                        startIcon={playButtonIcon()}
                        onClick={() => setIsPlaying(!isPlaying)}> {isPlaying ? 'Stop' : 'Play'}</Button>
                    <Button variant='contained'
                        sx={{ ml: 1 }}
                        color="neutral"
                        startIcon={muteButtonIcon()}
                        onClick={() => setIsMuted(!isMuted)}> {isMuted ? 'OFF' : 'ON'}</Button>
                </Box>
            </Stack>

        </React.Fragment>
    )
}

export default TVPlayer;
